<template>
  <div class="loginAds-page">
    <div class="global-header-wrap">
      <div class="left-part"></div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'loginAdsCreate' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <TableView
          :tableProp="tableProp"
          :tableData="tableData"
          :handleBtn="handleBtn"
          :currentPage="params.page"
          :pageSize="params.limit"
          @tableHandle="tableHandle"
        />
        <Pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="pageNum"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import TableView from "@/components/tableView";
import Pagination from "@/components/pagination";

export default {
  // mixins: [listMixin],
  components: {
    TableView,
    Pagination
  },
  computed: {
    tableProp() {
      let tableProp = [
        {
          prop: "title",
          label: "标题"
        },
        {
          prop: "updatedAt",
          label: "更新日期"
        },
        {
          prop: "public",
          label: "发布状态"
        }
      ];
      return tableProp;
    },
    handleBtn() {
      return [
        { style: "checkDetailsBtn", type: "edit", title: "编辑" },
        { style: "delBtn", type: "del", title: "删除" }
      ];
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      params: { limit: 20, page: 1, sortBy: "updatedAt" },
      currentItem: null
    };
  },
  methods: {
    async getList() {
      let res = await this.$http.getLoginAds(this.params);
      this.tableData = res.data.results;
      this.total = res.data.count;
    },
    async tableHandle(obj) {
      let { type, data } = obj;
      this.currentItem = data;
      if (type === "del") {
        this.del();
      } else if (type === "edit") {
        this.$router.push({
          name: "loginAdsCreate",
          query: { id: this.currentItem._id }
        });
      }
    },

    async del() {
      try {
        await this.$confirm(null, this.$t("alertMsg.delConfirm"), {
          confirmButtonText: this.$t("commonMsg.confirm"),
          cancelButtonText: this.$t("commonMsg.cancel"),
          showClose: false,
          center: true
        });
        await this.$http.delLoginAds(this.currentItem._id);
        this.getList();
      } catch (error) {}
    },
    pageNum(page) {
      this.params.page = page;
      this.getList();
    }
  },
  mounted() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.loginAds-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    .global-button-style {
      margin: 0;
    }
  }
}
</style>
